var map = {
	"./icon-car-w.svg": "5af2",
	"./icon-car.svg": "fb03",
	"./icon-certificate-w.svg": "72e3",
	"./icon-certificate.svg": "fa68",
	"./icon-fund.svg": "31a0",
	"./icon-house.svg": "f317",
	"./icon-person-w.svg": "8e01",
	"./icon-person.svg": "9f8c",
	"./icon-plane.svg": "68a5",
	"./icon-retirement.svg": "3934"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1fe9";